import { useState, useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import UserContext from "../UserContext";
import "./Register.css";
import "../styles/login.css";
import Logoname from "../img/logo/logo-name.png";
import ImgPhone from "../img/site/phone.png";
import LoginFooter from "../Components/LoginFooter";
import AppStore from "../img/logo/app-store.png";
import PlayStore from "../img/logo/google-play.png";
import { LoadingOutlined } from "@ant-design/icons";
import SEO from "../Components/SEO";

export default function ResetPassword() {
  const { user, mode, resetPassword, validateOTP } = useContext(UserContext);
  const [currentPage, setCurrentPage] = useState("reset");
  const [identifier, setidentifier] = useState("");
  const [vericationCode, setvericationCode] = useState("");
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  if (user.token) {
    history.push("/");
  }
  const handleidentifier = (e) => {
    setidentifier(e.target.value);
  };
  const handleVerificationCode = (e) => {
    setvericationCode(e.target.value);
  };
  const resetUserPassword = async (e) => {
    let action = currentPage;
    e.preventDefault();
    setLoading(true);
    let response;
    if (action === "reset") {
      response =
        (await resetPassword("password-reset", { email: identifier })) || {};
    } else
      response =
        (await validateOTP({ email: identifier, OTP_code: vericationCode })) ||
        {};

    let { message, success, error, token } = response;
    if (success) {
      window.Toast.fire({
        icon: "success",
        title: message || "Worked as expected",
      });

      if (action === "reset") setCurrentPage("validate");
      else history.push(`/confirm-reset-password?q=${token}`);
    } else {
      window.displayToastError(error);
    }
    setLoading(false);
  };
  // setting the theme
  const [dark, setDark] = useState(false);
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);
  return (
    <>
      <SEO title="Reset Password"></SEO>
      <div className={dark ? "w-full darkmode" : "w-full"}>
        <div className="">
          <div className="lg:flex gap-5 justify-center">
            <div className="w-1/4  hidden lg:block">
              <div className="flex justify-center">
                <img src={ImgPhone} alt="Twika showcase" />
              </div>
            </div>

            <div className="lg:w-1/4 p-0 mt-100">
              <div className="form-container border">
                <div className="logo-name w-full flex justify-center">
                  <img src={Logoname} alt="Our logo name" />
                </div>
                <div className="inputs-group">
                  <p className="my-2">Reset your password here</p>
                  <form onSubmit={resetUserPassword}>
                    <div className="form-group">
                      {currentPage === "reset" ? (
                        <input
                          autoComplete="off"
                          type="email"
                          id="email"
                          placeholder="Email"
                          value={identifier}
                          onChange={handleidentifier}
                          className="form-control"
                        />
                      ) : (
                        <input
                          autoComplete="off"
                          type="text"
                          id="text"
                          placeholder="Verification Code"
                          value={vericationCode}
                          onChange={handleVerificationCode}
                          className="form-control"
                        />
                      )}
                    </div>

                    <div className="form-group">
                      {loading ? (
                        <button
                          type="submit"
                          className="p-2 rounded-md bg-fire w-100 text-white opacity-50 gap-1 flex items-center justify-center"
                          style={{ fontSize: "13px" }}
                        >
                          {" "}
                          <LoadingOutlined />{" "}
                          <span>
                            {" "}
                            {currentPage === "reset"
                              ? "Sending"
                              : "Verifying"}{" "}
                            ...
                          </span>
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="p-2 rounded-md bg-fire w-100 text-white"
                          style={{ fontSize: "13px" }}
                        >
                          {currentPage === "reset"
                            ? "Send OTP Code"
                            : "Verify OTP"}
                        </button>
                      )}

                      <div className="flex justify-end mt-2 ">
                        <Link
                          to="/login"
                          className="text-gray-500 hover:underline"
                        >
                          Remember password
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="border mt-1 p-1 flex justify-center items-center">
                <span className="">
                  Don't have any account?{" "}
                  <b>
                    <Link to="/register"> Create One.</Link>
                  </b>
                </span>
              </div>
              {!dark && (
                <div className="mt-1 p-1 form-container">
                  <div className="account2">
                    <div className="app-stores flex w-full justify-center">
                      <img src={AppStore} alt="App Store" className="mr-2" />
                      <img
                        src={PlayStore}
                        alt="Google Play Store"
                        className="ml-2"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <LoginFooter />
      </div>
    </>
  );
}
